import { COMPONENT_FIELDS } from './formComponentFieldSchema';
import { FORM_COMPONENT_ADVANCED_INPUT_TYPE, FORM_COMPONENT_BASIC_INPUT_TYPE } from './formComponentInputTypeSchema';

export const FORM_BUILDER_TEXT = {
  [FORM_COMPONENT_BASIC_INPUT_TYPE.email]: {
    text: { en: '<p>Enter your email address.</p>', fr: '<p>Entrez votre adresse e-mail.</p>' },
  },
  [FORM_COMPONENT_BASIC_INPUT_TYPE.phone]: {
    text: { en: '<p>What is your phone number?</p>', fr: '<p>Quel est votre numéro de téléphone?</p>' },
  },
  [FORM_COMPONENT_BASIC_INPUT_TYPE.gender]: {
    text: { en: '<p>What is your gender?</p>', fr: '<p>Quel est votre sexe?</p>' },
  },
  [FORM_COMPONENT_BASIC_INPUT_TYPE.address]: {
    text: {
      en: '<p>What is your current address? Use the button below to search addresses.</p>',
      fr: '<p>Quel est votre adresse actuelle? Utilisez le bouton ci-dessous pour rechercher des adresses.</p>',
    },
  },
  [FORM_COMPONENT_BASIC_INPUT_TYPE.documentReview]: {
    confirmText: { en: 'Confirm', fr: 'Confirmer' },
    description: {
      en: '<p>You need to consent to the document after you read it</p>',
      fr: '<p>Vous devez accepter le document après avoir lu</p>',
    },
    acknowledgeContent: {
      en: '<p>I acknowledge that I have read all the required documents.</p>',
      fr: '<p>Je reconnais avoir pris connaissance de tous les documents requis.</p>',
    },
    url: { en: '', fr: '' },
  },
  [FORM_COMPONENT_BASIC_INPUT_TYPE.bankAccountNumber]: {
    text: {
      en:
        '<p><strong>Bank Account Number:</strong> The Bank Account Number is the group of 7 to 12 numbers after the Financial Institution Number at the bottom of your cheque. You can view our guide or enter the numbers directly.</p>',
      fr:
        "<p><strong>Numéro de compte bancaire:</strong> Le numéro de compte bancaire est le groupe de 7 à 12 chiffres qui suit le numéro de l'institution financière au bas de votre chèque. Vous pouvez consulter notre guide ou saisir directement les numéros.</p>",
    },
  },
  [FORM_COMPONENT_BASIC_INPUT_TYPE.routingNumber]: {
    text: {
      en:
        '<p><strong>Routing Number:</strong> The Routing Number is the first group of 9 numbers at the bottom of your cheque. You can view our guide or enter the numbers directly.</p>',
      fr:
        "<p><strong>Numéro de routage:</strong> Le numéro d'acheminement est le premier groupe de 9 chiffres au bas de votre chèque. Vous pouvez consulter notre guide ou saisir directement les numéros.</p>",
    },
  },
  [FORM_COMPONENT_BASIC_INPUT_TYPE.branchTransitNumber]: {
    text: {
      en:
        '<p><strong>Branch Transit Number:</strong> The Branch Transit Number is the first group of 5 numbers at the bottom of your cheque. You can view our guide or enter the numbers directly.</p>',
      fr:
        '<p><strong>Numéro de transit de la branche:</strong> Le numéro de transit de la succursale est le premier groupe de cinq chiffres au bas de votre chèque. Vous pouvez consulter notre guide ou saisir directement les numéros.</p>',
    },
  },
  [FORM_COMPONENT_BASIC_INPUT_TYPE.financialInstitutionNumber]: {
    text: {
      en:
        '<p><strong>Financial Institution Number:</strong> The Financial Institution Number is the group of 3 numbers after the Branch Transit Number at the bottom of your cheque. You can view our guide or enter the numbers directly.</p>',
      fr:
        "<p><strong>Numéro de l'institution financière:</strong> Le numéro de l'institution financière est le groupe de trois chiffres qui suit le numéro de transit de la succursale au bas de votre chèque. Vous pouvez consulter notre guide ou saisir directement les numéros.</p>",
    },
  },
  [FORM_COMPONENT_BASIC_INPUT_TYPE.correspondenceLanguage]: {
    text: {
      en: '<p>Choose your preferred correspondence language</p>',
      fr: '<p>Choisissez votre langue de correspondance préférée</p>',
    },
  },
  [FORM_COMPONENT_BASIC_INPUT_TYPE.sin]: {
    text: { en: '<p>Enter your Social Insurance Number</p>', fr: "<p>Saisissez votre numéro d'assurance sociale</p>" },
  },
  [FORM_COMPONENT_BASIC_INPUT_TYPE.ssn]: {
    text: { en: '<p>Enter your Social Security Number.</p>', fr: '<p>Saisissez votre numéro de sécurité sociale.</p>' },
  },
  [FORM_COMPONENT_BASIC_INPUT_TYPE.signature]: {
    text: { en: '<p>Add your signature here</p>', fr: '<p>Ajoutez votre signature ici</p>' },
  },
  [FORM_COMPONENT_ADVANCED_INPUT_TYPE.sinAdvanced]: {
    [FORM_COMPONENT_BASIC_INPUT_TYPE.sin]: {
      text: { en: '<p>Enter your Social Insurance Number</p>', fr: "<p>Saisissez votre numéro d'assurance sociale</p>" },
    },
    permit: {
      text: { en: 'Require permit if SIN begins with 9', fr: 'Nécessiter un permis si le NAS commence par 9' },
    },
    permitType: {
      text: { en: '<p>Select your permit type</p>', fr: '<p>Sélectionner ton type de permis</p>' },
    },
    endDate: {
      text: { en: '<p>What is the end date of your permit?</p>', fr: "<p>Quelle est la date d'expiration de ton permis?</p>" },
    },
    needPermitPhotoInfo: {
      text: {
        en: '<p>We will need a photo of your valid permit.</p>',
        fr: "<p>Nous aurons besoin d'une photo de ton permis valide.</p>",
      },
    },
    permitPhotoInfo: {
      text: {
        en: '<p>Make sure you follow these instructions when taking your photo:</p>',
        fr: '<p>Assure-toi de suivre ces instructions lors de la prise de ta photo:</p>',
      },
    },
    permitPhoto: {
      text: {
        en: '<p>All of the pages of the permit, and the permit’s end date, must be clearly visible in the photo preview</p>',
        fr:
          "<p>Toutes les pages du permis, ainsi que la date d'expiration du permis, doivent être clairement visibles dans l'aperçu de la photo.</p>",
      },
    },
  },
  [FORM_COMPONENT_ADVANCED_INPUT_TYPE.ssnAdvanced]: {
    [FORM_COMPONENT_BASIC_INPUT_TYPE.ssn]: {
      text: { en: '<p>Enter your Social Security Number.</p>', fr: '<p>Saisissez votre numéro de sécurité sociale.</p>' },
    },
  },
  [FORM_COMPONENT_ADVANCED_INPUT_TYPE.signatureAdvanced]: {
    text: { en: 'Final review signature', fr: 'Signature de fin' },
  },
  [FORM_COMPONENT_ADVANCED_INPUT_TYPE.documentPreview]: {
    [COMPONENT_FIELDS.codeofconductandethics]: {
      documentReview: {
        description: {
          en: '<p>You need to consent to this Code after you have read it.</p>',
          fr: '<p>Vous devez accepter ce Code après avoir lu le Code.</p>',
        },
        acknowledgeContent: {
          en:
            '<p>I acknowledge that I have read and understood the <span>[business_name]</span> Code of Conduct and Ethics (the "Code") and signify that I will comply with the rules, policies and procedures set forth in the Code.</p>',
          fr:
            "<p> Je reconnais avoir lu et compris le Code de conduite et d'éthique de <span data-tag=\"true\">[business_name]</span> (le « Code ») et j'atteste que je m'engage à respecter toutes les règles, politiques et procédures énoncées dans le Code.</p>",
        },
      },
      text: {
        en:
          '<p>Please review the <span>[business_name]</span> code of Conduct and Ethics. It addresses various topics and includes the rules and guidelines for personal conduct and ethical decisions in the course of your work.</p>',
        fr: "<p>Veuillez examiner le Code de conduite et d'éthique de <span>[business_name]</span>.</p>",
      },
    },
    [COMPONENT_FIELDS.privacynoticeforemployees]: {
      documentReview: {
        description: {
          en: '<p>You need to consent to this Code after you have read it.</p>',
          fr: '<p>Vous devez accepter ce Code apres avoir lu le Code.</p>',
        },
        acknowledgeContent: {
          en:
            '<p>I acknowledge that I have read and understood the <span>[business_name]</span> Privacy Notice for Employees and signify that I will comply with the rules, policies and procedures set forth in this employee privacy policy.</p>',
          fr:
            '<p>Je reconnais avoir lu et compris le <span>[business_name]</span> Notice de Confidentialité des Employés et m’y engage.</p>',
        },
      },
      text: {
        en:
          '<p>Please review the <span>[business_name]</span> Privacy Notice for Employees that informs you on how your personal information is collected, for which purpose and how you may exercise certain privacy rights.</p>',
        fr:
          "<p>Je reconnais avoir lu et compris l'Avis sur la protection des renseignements personnels des employés et j'atteste que je m'engage à respecter toutes les règles, politiques et procédures énoncées dans cette politique de vie privée des employés</p>",
      },
    },
    [COMPONENT_FIELDS.electronicmonitoringpolicy]: {
      documentReview: {
        description: {
          en: '<p>You need to consent to this Employee Privacy Policy after you have read it.</p>',
          fr:
            '<p>Vous devez accepter cette Politique de Vie Privée des Employés apres avoir lu la Politique de Vie Privée des Employés.</p>',
        },
        acknowledgeContent: {
          en:
            '<p>I acknowledge that I have read and understood the Electronic Monitoring Policy and signify that I will comply with the rules, policies and procedures set forth in this employee privacy policy.</p>',
          fr:
            "<p>Je reconnais avoir lu et compris la Politique de surveillance électronique de <span>[business_name]</span> et j'atteste que je m'engage à respecter toutes les règles, politiques et procédures énoncées dans cette politique de vie privée des employés</p>",
        },
      },
      text: {
        en:
          '<p>Please review the Electronic Monitoring Policy that governs the use of <span>[business_name]</span> equipment and the tools used to monitor productive work.</p>',
        fr: '<p>Veuillez lire attentivement la <span>[business_name]</span> Politique de surveillance électronique.</p>',
      },
    },
  },
  [FORM_COMPONENT_ADVANCED_INPUT_TYPE.canadianBank]: {
    info: {
      text: {
        en:
          '<p>In order to set you up in our system, we will need your banking information. These numbers can be found on a cheque or within your online banking portal.</p>',
        fr:
          '<p>Pour vous inscrire dans notre système, nous avons besoin de vos informations bancaires. Ces chiffres peuvent être trouvés sur un chèque ou dans le portail en ligne de votre banque.</p>',
      },
    },
    enableVoidCheque: {
      text: { en: 'Enable void cheque image upload', fr: 'Activer l’upload de la photo du chèque vide' },
    },
    voidChequePhotoInfo: {
      text: {
        en: '<p>We now need a photo of your void cheque.</p>',
        fr: '<p>Nous avons maintenant besoin d’une photo de votre chèque vide.</p>',
      },
    },
    photoInstruction: {
      text: {
        en: '<p>Make sure you follow these instructions when taking your photo:</p>',
        fr: '<p>Assurez-vous de suivre ces instructions lorsque vous prenez votre photo:</p>',
      },
    },
    voidChequePhoto: {
      text: {
        en:
          '<p>SPECIMEN or VOID must be written on the cheque. Make sure all the numbers on the void cheque are clearly visible in the photo preview. Handwritten information is not accepted.</p>',
        fr:
          '<p>SPECIMEN ou VOID doit être écrit sur le chèque. Assurez-vous de voir clairement tous les nombres sur le chèque vide. Les informations manuscrites ne sont pas acceptées.</p>',
      },
    },
  },
  [FORM_COMPONENT_ADVANCED_INPUT_TYPE.americanBank]: {
    info: {
      text: {
        en:
          '<p>In order to set you up in our system, we need your banking information. These numbers can be found on a cheque or within your bank’s online portal.</p>',
        fr:
          '<p>Pour vous inscrire dans notre système, nous avons besoin de vos informations bancaires. Ces chiffres peuvent être trouvés sur un chèque ou dans le portail en ligne de votre banque.</p>',
      },
    },
    [COMPONENT_FIELDS.bankAccountNumber]: {
      text: {
        en:
          '<p><strong>Bank Account Number:</strong> The Bank Account Number is the second group of 10-12 numbers at the bottom of your check. You can view our guide or enter the numbers directly.</p>',
        fr:
          '<p><strong>Bank Account Number:</strong> Le Numéro de compte bancaire est le deuxième groupe de 10-12 chiffres en bas de votre chèque. Vous pouvez consulter notre guide ou saisir les chiffres directement.</p>',
      },
    },
    enableVoidCheque: {
      text: { en: 'Enable void cheque image upload', fr: 'Activer l’upload de la photo du chèque vide' },
    },
    needPhotoInfo: {
      text: {
        en: '<p>We now need a photo of your void cheque.</p>',
        fr: '<p>Nous avons maintenant besoin d’une photo de votre chèque vide.</p>',
      },
    },
    photoInstruction: {
      text: {
        en: '<p>Make sure you follow these instructions when taking your photo:</p>',
        fr: '<p>Assurez-vous de suivre ces instructions lorsque vous prenez votre photo:</p>',
      },
    },
    voidChequePhoto: {
      text: {
        en:
          '<p>SPECIMEN or VOID must be written on the cheque. Make sure all the numbers on the void cheque are clearly visible in the photo preview. Handwritten information is not accepted.</p>',
        fr:
          '<p>SPECIMEN ou VOID doit être écrit sur le chèque. Assurez-vous de voir clairement tous les nombres sur le chèque vide. Les informations manuscrites ne sont pas acceptées.</p>',
      },
    },
  },
  [FORM_COMPONENT_ADVANCED_INPUT_TYPE.earliestStartDate]: {
    text: {
      en:
        '<p>To proceed, let us know the earliest date that you are available to work! This position can start as early as <span>[position_start_date]</span> </p>',
      fr:
        '<p>Pour continuer, nous voulons savoir la date la plus tardive que vous pouvez travailler! Cette position peut commencer comme tard que <span>[position_start_date]</span></p>',
    },
  },
  [FORM_COMPONENT_ADVANCED_INPUT_TYPE.addressValidator]: {
    [FORM_COMPONENT_BASIC_INPUT_TYPE.address]: {
      text: {
        en: '<p>What is your current address? Use the button below to search addresses.</p>',
        fr: '<p>Quelle est votre adresse actuelle? Utilisez le bouton ci-dessous pour rechercher des adresses.</p>',
      },
    },
    apartmentYN: {
      text: { en: 'Does your address have an apartment number?', fr: "Votre adresse comporte-t-elle un numéro d'appartement ?" },
    },
    [COMPONENT_FIELDS.apartment]: {
      text: { en: 'Enter your apartment number.', fr: "Saisissez votre numéro d'appartement." },
    },
  },
  [FORM_COMPONENT_ADVANCED_INPUT_TYPE.emergencyContact]: {
    yesNo: {
      text: {
        en: '<p>Do you have someone we can reach in case of an emergency?</p>',
        fr: '<p>Avez-vous quelqu’un que nous pouvons joindre en cas d’urgence?</p>',
      },
    },
    [COMPONENT_FIELDS.emergencyContactFirstName]: {
      text: { en: '<p>What is their first name?</p>', fr: '<p>Quel est leur nom de famille?</p>' },
    },
    [COMPONENT_FIELDS.emergencyContactLastName]: {
      text: { en: '<p>What is their last name?</p>', fr: '<p>Quel est leur prénom?</p>' },
    },
    [COMPONENT_FIELDS.emergencyContactPhoneNumber]: {
      text: {
        en: '<p>What is their phone number? We will only contact them in case of an emergency.</p>',
        fr: '<p>Quel est leur numéro de téléphone? Nous ne nous contacterons que dans le cas d’urgence.</p>',
      },
    },
  },
  [FORM_COMPONENT_ADVANCED_INPUT_TYPE.miscellaneous]: {
    [COMPONENT_FIELDS.contractDetailsWordings]: {
      text: {
        en: 'Any additional information you would like to share with us?',
        fr: 'Avez-vous des informations additionnelles que vous souhaitez partager avec nous?',
      },
    },
  },
  [FORM_COMPONENT_ADVANCED_INPUT_TYPE.fullName]: {
    info: {
      text: {
        en: `<p>Let's start with your full name. This is the name found on your government identification.</p>`,
        fr: `<p>Commençons par ton nom complet. Il s'agit du nom figurant sur ta pièce d'identité officielle.</p>`,
      },
    },
    firstNameYN: {
      text: {
        en: '<p>Is <strong><span>[first_name]</span></strong> your legal first name?</p>',
        fr: '<p><strong><span>[first_name]</span></strong> est-il ton prénom légal?</p>',
      },
    },
    [COMPONENT_FIELDS.firstName]: {
      text: { en: 'Enter your legal first name.', fr: 'Saisis ton prénom légal.' },
    },
    middleNameYN: {
      text: { en: '<p>Do you have a legal middle name ?</p>', fr: '<p>As-tu un deuxième prénom légal?</p>' },
    },
    [COMPONENT_FIELDS.middleName]: {
      text: { en: 'Enter your legal middle name.', fr: 'Saisis ton deuxième prénom légal.' },
    },
    lastNameYN: {
      text: {
        en: '<p>Is <strong><span>[last_name]</span></strong> your legal last name?</p>',
        fr: '<p><strong><span>[last_name]</span></strong> est-il ton nom de famille légal?</p>',
      },
    },
    [COMPONENT_FIELDS.lastName]: {
      text: { en: 'Enter your legal last name.', fr: 'Saisis ton nom de famille légal.' },
    },
  },
} as const;
